import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { RootScopeService } from '../../core/shared-service/root-scope.service';

@Component({
  selector: 'app-custom-body-modal-popup',
  templateUrl: './custom-body-modal-popup.component.html',
  styleUrls: ['./custom-body-modal-popup.component.scss']
})
export class CustomBodyModalPopupComponent implements OnInit {
  @Output() callOnPositiveBtnClick: EventEmitter<string> = new EventEmitter();
  @Output() callOnNegativeBtnClick: EventEmitter<string> = new EventEmitter();
  @Input() popupPropertieList: any;

  rootScopeData: RootScopeDeclare;
  isRtl: boolean;
  constructor(private rootScopeService: RootScopeService) {
    this.getRootScopeData();
  }

  ngOnInit() {
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  onNegativeButtonClick(): void {
    this.callOnNegativeBtnClick.emit();
  }

  onPositiveButtonClick(): void {
    this.callOnPositiveBtnClick.emit();
  }

  stopBubbling(e: Event) {
    e.stopPropagation();
  }
}
